import { render, staticRenderFns } from "./FinalDaPesquisa.vue?vue&type=template&id=36d14d0b&"
import script from "./FinalDaPesquisa.vue?vue&type=script&lang=js&"
export * from "./FinalDaPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports